import { twMerge } from "tailwind-merge";

type StatBlockProps = {
  value: string | number;
  label: string;
  accent?: boolean;
  className?: string;
};

function StatBlock({ value, label, accent = false, className }: StatBlockProps) {
  return (
    <div className={twMerge("text-center", className)}>
      <div
        className={twMerge(
          "text-xl font-extrabold leading-6",
          accent
            ? "bg-brand-gradient bg-clip-text text-transparent"
            : "text-ink-primary"
        )}
      >
        {value}
      </div>
      <div className="text-xs font-medium text-ink-muted">{label}</div>
    </div>
  );
}

export default StatBlock;
